var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('crypto'),
    randomBytes = _require.randomBytes;

var base64url = require('./base64url');

var errors = require('../errors');

var ZERO = BigInt(0);
var ONE = BigInt(1);
var TWO = BigInt(2);

var toJWKParameter = function toJWKParameter(n) {
  var hex = n.toString(16);
  return base64url.encodeBuffer(Buffer.from(hex.length % 2 ? "0".concat(hex) : hex, 'hex'));
};

var fromBuffer = function fromBuffer(buf) {
  return BigInt("0x".concat(buf.toString('hex')));
};

var bitLength = function bitLength(n) {
  return n.toString(2).length;
};

var eGcdX = function eGcdX(a, b) {
  var x = ZERO;
  var y = ONE;
  var u = ONE;
  var v = ZERO;

  while (a !== ZERO) {
    var q = b / a;
    var r = b % a;
    var m = x - u * q;
    var n = y - v * q;
    b = a;
    a = r;
    x = u;
    y = v;
    u = m;
    v = n;
  }

  return x;
};

var gcd = function gcd(a, b) {
  var shift = ZERO;

  while (!((a | b) & ONE)) {
    a >>= ONE;
    b >>= ONE;
    shift++;
  }

  while (!(a & ONE)) {
    a >>= ONE;
  }

  do {
    while (!(b & ONE)) {
      b >>= ONE;
    }

    if (a > b) {
      var x = a;
      a = b;
      b = x;
    }

    b -= a;
  } while (b);

  return a << shift;
};

var modPow = function modPow(a, b, n) {
  a = toZn(a, n);
  var result = ONE;
  var x = a;

  while (b > 0) {
    var leastSignificantBit = b % TWO;
    b = b / TWO;

    if (leastSignificantBit === ONE) {
      result = result * x;
      result = result % n;
    }

    x = x * x;
    x = x % n;
  }

  return result;
};

var randBetween = function randBetween(min, max) {
  var interval = max - min;
  var bitLen = bitLength(interval);
  var rnd;

  do {
    rnd = fromBuffer(randBits(bitLen));
  } while (rnd > interval);

  return rnd + min;
};

var randBits = function randBits(bitLength) {
  var byteLength = Math.ceil(bitLength / 8);
  var rndBytes = randomBytes(byteLength); // Fill with 0's the extra bits

  rndBytes[0] = rndBytes[0] & Math.pow(2, bitLength % 8) - 1;
  return rndBytes;
};

var toZn = function toZn(a, n) {
  a = a % n;
  return a < 0 ? a + n : a;
};

var odd = function odd(n) {
  var r = n;

  while (r % TWO === ZERO) {
    r = r / TWO;
  }

  return r;
}; // not sold on these values


var maxCountWhileNoY = 30;
var maxCountWhileInot0 = 22;

var getPrimeFactors = function getPrimeFactors(e, d, n) {
  var r = odd(e * d - ONE);
  var countWhileNoY = 0;
  var y;

  do {
    countWhileNoY++;

    if (countWhileNoY === maxCountWhileNoY) {
      throw new errors.JWKImportFailed('failed to calculate missing primes');
    }

    var countWhileInot0 = 0;
    var i = modPow(randBetween(TWO, n), r, n);
    var o = ZERO;

    while (i !== ONE) {
      countWhileInot0++;

      if (countWhileInot0 === maxCountWhileInot0) {
        throw new errors.JWKImportFailed('failed to calculate missing primes');
      }

      o = i;
      i = i * i % n;
    }

    if (o !== n - ONE) {
      y = o;
    }
  } while (!y);

  var p = gcd(y - ONE, n);
  var q = n / p;
  return p > q ? {
    p: p,
    q: q
  } : {
    p: q,
    q: p
  };
};

module.exports = function (jwk) {
  var e = fromBuffer(base64url.decodeToBuffer(jwk.e));
  var d = fromBuffer(base64url.decodeToBuffer(jwk.d));
  var n = fromBuffer(base64url.decodeToBuffer(jwk.n));

  if (d >= n) {
    throw new errors.JWKInvalid('invalid RSA private exponent');
  }

  var _getPrimeFactors = getPrimeFactors(e, d, n),
      p = _getPrimeFactors.p,
      q = _getPrimeFactors.q;

  var dp = d % (p - ONE);
  var dq = d % (q - ONE);
  var qi = toZn(eGcdX(toZn(q, p), p), p);
  return _objectSpread({}, jwk, {
    p: toJWKParameter(p),
    q: toJWKParameter(q),
    dp: toJWKParameter(dp),
    dq: toJWKParameter(dq),
    qi: toJWKParameter(qi)
  });
};